import { STATUS_TYPE } from "taltech-styleguide";
import { ErrorScreenProps , ErrorScreen} from "./ErrorScreen";

const Error404Dot1Screen: React.FC<any> = () => {
  const props: ErrorScreenProps = {
    variant: STATUS_TYPE.WARNING,
    status: 404.1,
    title: "Resource not found",
    message: "The page you are looking for was not found",
  };
  return <ErrorScreen {...props} />;
};

export {Error404Dot1Screen};
